import vendor from '@/api/administration/vendor-profile'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  companies: [],
  edit_data: {}
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  RECEIVE_COMPANY(state, companies) {
    state.companies = companies
  },
  SET_EDIT_DATA(state, edit_data) {
    state.edit_data = edit_data
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attributes
    )

    return vendor.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return vendor.store(data)
  },

  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await vendor.find(id)
      context.commit('SET_EDIT_DATA', response.data)
      return Promise.resolve(response.data)
    }
  },
  update(context, data) {
    return vendor.update(data)
  },

  delete(context, id) {
    return vendor.destroy(id)
  },

  async dataBeforeCreate(context) {
    if (!context.state.companies.length > 0) {
      let response = await vendor.getCompany()
      context.commit('RECEIVE_COMPANY', response)
    }
  }
}
